package br.com.vvrefeicoes.portal.core.ui.theme

import androidx.compose.ui.unit.dp

object AppSpacing {
    val none = 0.dp
    val space4 = 4.dp
    val space8 = 8.dp
    val space12 = 12.dp
    val space16 = 16.dp
    val space20 = 20.dp
    val space24 = 24.dp
    val space32 = 32.dp
    val space40 = 40.dp
    val space48 = 48.dp
    val space64 = 64.dp
}
